import DetailListView from "./DetailListView";
export default DetailListView;
